import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { DocsContextProvider } from 'containers/Docs/context/DocsContext';
import DocsHome from 'containers/Docs/DocsHome';

const Docs = () => {
  const { url } = useRouteMatch();
  return (
    <>
      <DocsContextProvider>
        <Route path={`${url}/:docId?`} component={DocsHome} />
      </DocsContextProvider>
    </>
  );
};

export default Docs;
